import * as l from "react";
import { useState as g } from "react";
import { _ as p } from "./tslib.es6-CBKHJX9H.js";
function o(e, u) {
  return typeof e == "function" ? e(u) : e && (e.current = u), e;
}
function E(e, u) {
  var n = g(function() {
    return {
      // value
      value: e,
      // last callback
      callback: u,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var c = n.value;
          c !== r && (n.value = r, n.callback(r, c));
        }
      }
    };
  })[0];
  return n.callback = u, n.facade;
}
var M = typeof window < "u" ? l.useLayoutEffect : l.useEffect, v = /* @__PURE__ */ new WeakMap();
function b(e, u) {
  var n = E(null, function(r) {
    return e.forEach(function(c) {
      return o(c, r);
    });
  });
  return M(function() {
    var r = v.get(n);
    if (r) {
      var c = new Set(r), i = new Set(e), t = n.current;
      c.forEach(function(a) {
        i.has(a) || o(a, null);
      }), i.forEach(function(a) {
        c.has(a) || o(a, t);
      });
    }
    v.set(n, e);
  }, [e]), n;
}
function d(e) {
  return e;
}
function h(e, u) {
  u === void 0 && (u = d);
  var n = [], r = !1, c = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var t = u(i, r);
      return n.push(t), function() {
        n = n.filter(function(a) {
          return a !== t;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var t = n;
        n = [], t.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var t = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), t = n;
      }
      var m = function() {
        var f = t;
        t = [], f.forEach(i);
      }, s = function() {
        return Promise.resolve().then(m);
      };
      s(), n = {
        push: function(f) {
          t.push(f), s();
        },
        filter: function(f) {
          return t = t.filter(f), n;
        }
      };
    }
  };
  return c;
}
function k(e, u) {
  return u === void 0 && (u = d), h(e, u);
}
function w(e) {
  e === void 0 && (e = {});
  var u = h(null);
  return u.options = p({ async: !0, ssr: !1 }, e), u;
}
export {
  w as a,
  k as c,
  b as u
};
